import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
import { ThemeProvider } from 'styled-components';

import theme from '../style/theme';
import Header from './header';
import Footer from './Footer';
import GlobalStyle from '../style/global-styles';


const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <ThemeProvider theme={theme}>
        <>
          <Helmet
            title={data.site.siteMetadata.title}
            meta={[
              { name: 'description', content: 'Grow your Instagram™ account. Get more followers and save time by delegating likes.' },
              { name: 'keywords', content: 'growth, instagram, auto, like' },
              { name: 'robots', content: 'noindex' },
            ]}
          >
            <html lang="en" />
          </Helmet>
          <GlobalStyle/>
          <Header/>
          <div>
            {children}
          </div>
          <Footer/>
        </>
      </ThemeProvider>
    )}
  />
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
